module.exports = __webpack_public_path__ + "media/assets/Explore-2d2344aaae605d3bbdfcf45c097263ad.svg";